import { render, staticRenderFns } from "./NodeServer.vue?vue&type=template&id=bdc7cecc&scoped=true"
import script from "./NodeServer.vue?vue&type=script&lang=js"
export * from "./NodeServer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdc7cecc",
  null
  
)

export default component.exports